import type { InputHTMLAttributes } from 'react'
import React, { forwardRef, ReactNode } from 'react'

import { AdornmentPosition } from '@/models/common'

import { InputAdornment } from './input-adornment'
import { Border, InputWrapper, StyledInput } from './styled-input'

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'disabled' | 'fieldValue' | 'valueFormat'> {
  error?: boolean
  type?: 'text' | 'tel' | 'password'
  as?: keyof React.JSX.IntrinsicElements
  adornment?: ReactNode
  adornmentPosition?: AdornmentPosition
  isDisabled?: boolean
  fieldValue?: unknown
  valueFormat?: unknown
  floatvalue?: number
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ error, adornment, adornmentPosition, isDisabled, fieldValue, valueFormat, floatvalue, ...rest }, ref) => (
    <InputWrapper>
      <StyledInput disabled={isDisabled} $adornmentPosition={adornmentPosition} $error={error} ref={ref} {...rest} />
      <Border $error={error} />
      {!!adornment && <InputAdornment $adornmentPosition={adornmentPosition}>{adornment}</InputAdornment>}
    </InputWrapper>
  ),
)

export default Input
